import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import * as actions from 'react/api/actions/stopDetailsPopup';
import ButtonWithIcon from 'react/components/ButtonWithIcon';
import { 
  signatureHeatMapIcon,
  signatureHeatMapIconActive
} from 'react/utils/stopDetailsPopupBase64Icons.js';

class SignatureHeatMapButton extends Component {
  
  toggleSignatureHeatMap = (e) => {
    const {
      routeId, stopId, enableSignatureHeatMapAction, 
      disableSignatureHeatMapAction, signatureHeatMapIsEnabled,
      requestSignatureHeatMapAction, removeSignatureHeatMapFromMapAction
    } = this.props;
    e.stopPropagation();
    removeSignatureHeatMapFromMapAction(routeId, stopId);
    if (signatureHeatMapIsEnabled) {
      disableSignatureHeatMapAction(routeId, stopId);
    } else {
      enableSignatureHeatMapAction(routeId, stopId);
      requestSignatureHeatMapAction(routeId, stopId);    
    }
  }

  compomentDidMount = () => {
    const { 
      routeId, stopId, signatureHeatMapIsEnabled, requestSignatureHeatMapAction 
    } = this.props;
    if (signatureHeatMapIsEnabled) {
      requestSignatureHeatMapAction(routeId, stopId);
    }
  }

  render() {
    const { signatureHeatMapIsEnabled, ...others } = this.props;
    return (
      <ButtonWithIcon
        label={Monet.I18n.getResourcesByKey('routeDetails.stopDetailsPopup.signatureHeatmap')}
        isActive={signatureHeatMapIsEnabled} 
        iconUrl={signatureHeatMapIcon}
        activeIconUrl={signatureHeatMapIconActive}
        onClick={this.toggleSignatureHeatMap}
        {...others}
      />
    );
  }
}

SignatureHeatMapButton.propTypes = {
  routeId: PropTypes.oneOfType([ PropTypes.string, PropTypes.number]).isRequired,
  stopId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  signatureHeatMapIsEnabled: PropTypes.bool.isRequired,
  enableSignatureHeatMapAction: PropTypes.func.isRequired,
  disableSignatureHeatMapAction: PropTypes.func.isRequired,
  requestSignatureHeatMapAction: PropTypes.func.isRequired,
  removeSignatureHeatMapFromMapAction: PropTypes.func.isRequired
}

const mapStateToProps = ({ stopDetailsPopup }, { routeId, stopId }) => ({ 
  signatureHeatMapIsEnabled: stopDetailsPopup.getIn(['actionButtons', String(routeId), String(stopId), 'signatureHeatMapIsEnabled'], false)
});

const mapDispatchToProps = (dispatch) => ({
  enableSignatureHeatMapAction: bindActionCreators(actions.enableSignatureHeatMap, dispatch),
  disableSignatureHeatMapAction: bindActionCreators(actions.disableSignatureHeatMap, dispatch),
  requestSignatureHeatMapAction: bindActionCreators(actions.requestSignatureHeatMap, dispatch),
  removeSignatureHeatMapFromMapAction: bindActionCreators(actions.removeSignatureHeatMapFromMap, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(SignatureHeatMapButton);

